import { Helmet } from 'react-helmet-async'
import { useEffect, useState } from 'react'
import { useMatch } from 'react-router-dom'
import { useShop } from 'shop/hooks'

interface Props {
  seoDescription?: string | null
  type: 'merchant' | 'store' | 'product'
}

export const MetaDescription = ({ seoDescription, type }: Props) => {
  const { partner } = useShop()
  const { seo } = partner || {}

  const [modalMode, setModalMode] = useState(false)

  const metaId = 'meta-description'
  const productPath = useMatch('/store/:store/:product')

  useEffect(() => {
    if (productPath) {
      setModalMode(true)
    } else {
      setModalMode(false)
    }
  }, [productPath])

  if (!seo?.enabled || !seoDescription || (modalMode && type !== 'product')) {
    return <></>
  }

  return (
    <Helmet>
      <meta name='description' id={metaId} content={seoDescription}></meta>
    </Helmet>
  )
}
